export interface ICashFlowStatementTotals {
    previousTotal: number;
    currentTotal: number;
}
